//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'


export default {
  props: {
    work: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    workContents () {
      return this.work.get('content').split('\n')
    }
  },
  methods: {
    showMsg () {
      if (this.user) {
        // console.log(this.work)
      } else {
        console.log('请先登录')
      }
    },

    clickLike () {
      if (!this.user) {
        this.$vux.toast.text('请先登录!', 'middle')
        return
      }
      this.$emit('click-like-btn', this.work)
    },

    goToWorkPost () {
      this.$router.push({
        name: 'workPost',
        params: {
          workId: this.work.id
        }
      })
    },

    goToWork () {
      this.$router.push({
        name: 'work',
        params: {
          id: this.work.id
        }
      })
    },

    goToAuthor () {
      this.$router.push({
        name: 'author',
        params: {
          id: this.work.get('author').id
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/nav_poetry/PoetryListItem.vue